import { ResultTag } from 'components/ResultTag'
import useAuctionCountdown from 'hooks/useAuctionCountdown'
import type { NFDAuctionAndPrice } from 'api/api-client'

export default function AuctionTag({ auction }: { auction: NFDAuctionAndPrice }) {
  const { timer } = useAuctionCountdown(auction)

  const { hours, minutes, seconds } = timer

  if (hours + minutes + seconds <= 0) {
    return (
      <div className="hidden md:flex w-full justify-end absolute p-3">
        <ResultTag label="Buy Now" brand />
      </div>
    )
  } else {
    return (
      <span className="inline-flex align-middle items-center px-2 py-0.5 rounded text-xs font-semibold bg-amber-800 text-white uppercase shadow-md">
        <svg
          className="-ml-0.5 mr-1.5 h-2 w-2 text-white animate-blink"
          fill="currentColor"
          viewBox="0 0 8 8"
        >
          <circle cx={4} cy={4} r={3} />
        </svg>
        Live Auction
      </span>
    )
  }
}
